"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const registry_1 = __importDefault(require("./registry"));
const userCard_1 = __importDefault(require("./userCard"));
const polls_1 = __importDefault(require("./polls"));
const registration_1 = __importDefault(require("./registration"));
const app_1 = __importDefault(require("./app"));
const registryOrder_1 = __importDefault(require("./registryOrder"));
const meeting_1 = __importDefault(require("./meeting"));
const digest_1 = __importDefault(require("./digest"));
const auth_1 = __importDefault(require("./auth"));
const protocolVersion_1 = __importDefault(require("./protocolVersion"));
const tariffs_1 = __importDefault(require("./tariffs"));
const payment_1 = __importDefault(require("./payment"));
const pretensions_1 = __importDefault(require("./pretensions"));
const petitions_1 = __importDefault(require("./petitions"));
const callCenter_1 = __importDefault(require("./callCenter"));
const cadastral_1 = __importDefault(require("./cadastral"));
const actualization_1 = __importDefault(require("./actualization"));
const contacts_1 = __importDefault(require("./contacts"));
const addresses_1 = __importDefault(require("./addresses"));
const documents_1 = __importDefault(require("./documents"));
const documentsSigning_1 = __importDefault(require("./documentsSigning"));
const errors_1 = __importDefault(require("./errors"));
exports.default = {
  app: app_1.default,
  registry: registry_1.default,
  polls: polls_1.default,
  userCard: userCard_1.default,
  registration: registration_1.default,
  registryOrder: registryOrder_1.default,
  meeting: meeting_1.default,
  digest: digest_1.default,
  auth: auth_1.default,
  protocolVersion: protocolVersion_1.default,
  tariffs: tariffs_1.default,
  payment: payment_1.default,
  pretensions: pretensions_1.default,
  petitions: petitions_1.default,
  callCenter: callCenter_1.default,
  cadastral: cadastral_1.default,
  actualization: actualization_1.default,
  contacts: contacts_1.default,
  addresses: addresses_1.default,
  documents: documents_1.default,
  documentsSigning: documentsSigning_1.default,
  errors: errors_1.default
};